import { render, staticRenderFns } from "./OrdersHeader.vue?vue&type=template&id=7bcace57&scoped=true"
import script from "./OrdersHeader.vue?vue&type=script&lang=ts"
export * from "./OrdersHeader.vue?vue&type=script&lang=ts"
import style0 from "./OrdersHeader.vue?vue&type=style&index=0&id=7bcace57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcace57",
  null
  
)

export default component.exports